import {
    GET_ACCOMODATIONS,
    SET_ACCOMODATION_ID, GET_EVENTS,
    GET_ROOM, GET_ROOMS,
    GET_ROOMS_BY_ID, GET_SERVICE_POINTS,
    GET_SESSIONS,
    SET_LOADING, SET_PAGINATION, GET_USER_SESSIONS,
    SET_SESSION_EVENT, SET_SESSION_ID, GET_STATS,
    GET_RESOURCES_GROUPS, GET_EVENT_RESOURCES_GROUPS,
    SET_SESSION_EVENT_TITLE, SET_REGULAR_ACCOMODATION,
    SET_SPECIAL_ACCOMODATION, SET_EVENT_PAGINATION,
    GET_CENTERS,
    SET_RESOURCE_GROUP_PAGINATION, SET_ACCOMODATION_PAGINATION,
    GET_ACCOMODATION, GET_EVENT, SEARCH,
    GET_RESOURCE_GROUP_TYPES, SET_RESOURCE_GROUP_TYPE_PAGINATION,
    SET_RESOURCE_TYPE_GROUPS_PAGINATION, GET_RESOURCE_TYPE_GROUPS,
    SET_ROOMS_PAGINATION,
    SET_RESOURCE_GROUPS_VALUES,
    GET_EVENT_STATS,
    SET_USER_EMAILS,
    GET_ROOM_TYPE_VALUES,
    SELECTED_EVENT,
    GET_STATES,
    GET_COUNTRIES,
    GET_OCCUPATIONS,
    FILTER,
    SET_SEARCH_PAGINATION,
    SET_INCOME_ITEMS,
    SET_YEAR_ON_YEAR_ITEMS,
    SET_EXPENDITURE_ITEMS,
    SET_CENTER_EXTENSION_ITEMS,
    SET_CENTER_PASTOR_ITEMS,
    SET_NON_COMITTED_DISCIPLES_ITEMS,
    SET_REPORTEE_ITEMS,
    SET_REGULAR_MEETING_ITEMS,
    SET_SPECIAL_MEETING_ITEMS,
    GET_CENTER_REPORTS_PAGINATION,
    GET_CENTER_REPORTS,
    GET_CENTER_REPORT
} from '../types'

const EventReducer = (state, action) => {

    switch (action.type) {

        case SET_INCOME_ITEMS:
            return {
                ...state,
                incomeItems: action.payload,
                loading: false
            }

        case SET_EXPENDITURE_ITEMS:
            return {
                ...state,
                expenditureItems: action.payload,
                loading: false
            }

        case SET_YEAR_ON_YEAR_ITEMS:
            return {
                ...state,
                yearOnYearItems: action.payload,
                loading: false
            }

        case SET_CENTER_EXTENSION_ITEMS:
            return {
                ...state,
                centerExtensionItems: action.payload,
                loading: false
            }

        case SET_CENTER_PASTOR_ITEMS:
            return {
                ...state,
                centerPastorItems: action.payload,
                loading: false
            }

        case SET_NON_COMITTED_DISCIPLES_ITEMS:
            return {
                ...state,
                nonComittedDisciplesItems: action.payload,
                loading: false
            }

        case SET_REPORTEE_ITEMS:
            return {
                ...state,
                reporteeItems: action.payload,
                loading: false
            }

        case SET_REGULAR_MEETING_ITEMS:
            return {
                ...state,
                regularMeetingItems: action.payload,
                loading: false
            }

        case SET_SPECIAL_MEETING_ITEMS:
            return {
                ...state,
                specialMeetingItems: action.payload,
                loading: false
            }

        case GET_COUNTRIES:
            return {
                ...state,
                countries: action.payload,
                loading: false
            }
        case GET_STATES:
            return {
                ...state,
                states: action.payload,
                loading: false
            }
        case GET_EVENTS:
            return {
                ...state,
                events: action.payload,
                loading: false
            }

        case GET_EVENT:
            return {
                ...state,
                event: action.payload,
                loading: false
            }

        case GET_EVENT_STATS:
            return {
                ...state,
                eventStats: action.payload,
                loading: false
            }

        case SELECTED_EVENT:
            return {
                ...state,
                selectedEvent: action.payload,
                loading: false
            }

        case SET_SESSION_EVENT:
            return {
                ...state,
                sessionEvent: action.payload,
                loading: false
            }

        // case GET_SESSION_EVENT:
        //     return {
        //         ...state,
        //         sessionEventUpdate: action.payload,
        //         loading: false
        //     }
        case SET_SESSION_EVENT_TITLE:
            return {
                ...state,
                sessionEventTitle: action.payload,
                loading: false
            }
        case GET_SESSIONS:
            return {
                ...state,
                sessions: action.payload,
                loading: false
            }
        case SET_USER_EMAILS:
            return {
                ...state,
                userEmails: action.payload,
                loading: false
            }
        case SET_SESSION_ID:
            return {
                ...state,
                sessionId: action.payload,
                loading: false
            }
        case GET_USER_SESSIONS:
            return {
                ...state,
                userSession: action.payload,
                loading: false
            }

        case GET_SERVICE_POINTS:
            return {
                ...state,
                sPoints: action.payload,
                loading: false
            }

        case SEARCH:
            return {
                ...state,
                search: action.payload,
                loading: false
            }

        case SET_PAGINATION:
            return {
                ...state,
                pagination: action.payload,
                loading: false
            }

        case SET_EVENT_PAGINATION:
            return {
                ...state,
                eventPagination: action.payload,
                loading: false
            }

        case SET_SEARCH_PAGINATION:
            return {
                ...state,
                searchPagination: action.payload,
                loading: false
            }

        case SET_RESOURCE_GROUP_TYPE_PAGINATION:
            return {
                ...state,
                rTypePagination: action.payload,
                loading: false
            }

        case GET_CENTER_REPORTS_PAGINATION:
            return {
                ...state,
                centerReportPagination: action.payload,
                loading: false
            }

        case SET_RESOURCE_TYPE_GROUPS_PAGINATION:
            return {
                ...state,
                rTypeGroupPagination: action.payload,
                loading: false
            }

        case SET_RESOURCE_GROUP_PAGINATION:
            return {
                ...state,
                rgPagination: action.payload,
                loading: false
            }

        case GET_OCCUPATIONS:
            return {
                ...state,
                occupations: action.payload,
                loading: false
            }

        case SET_ACCOMODATION_PAGINATION:
            return {
                ...state,
                accPagination: action.payload,
                loading: false
            }

        case GET_ACCOMODATIONS:
            return {
                ...state,
                accomodations: action.payload,
                loading: false
            }

        case GET_ACCOMODATION:
            return {
                ...state,
                accomodation: action.payload,
                loading: false
            }

        case SET_REGULAR_ACCOMODATION:
            return {
                ...state,
                regularAccomodation: action.payload,
                loading: false
            }

        case SET_SPECIAL_ACCOMODATION:
            return {
                ...state,
                specialAccomodation: action.payload,
                loading: false
            }

        case GET_ROOMS:
            return {
                ...state,
                rooms: action.payload,
                loading: false
            }

        case SET_ROOMS_PAGINATION:
            return {
                ...state,
                roomsPagination: action.payload,
                loading: false
            }

        case GET_ROOMS_BY_ID:
            return {
                ...state,
                accomodationRooms: action.payload,
                loading: false
            }

        case SET_ACCOMODATION_ID:
            return {
                ...state,
                accomodationId: action.payload,
                loading: false
            }

        case GET_RESOURCE_GROUP_TYPES:
            return {
                ...state,
                resourceGroupTypes: action.payload,
                loading: false
            }

        case GET_RESOURCE_TYPE_GROUPS:
            return {
                ...state,
                resourceTypeGroups: action.payload,
                loading: false
            }

        case GET_RESOURCES_GROUPS:
            return {
                ...state,
                resourceGroups: action.payload,
                loading: false
            }

        case SET_RESOURCE_GROUPS_VALUES:
            return {
                ...state,
                resourceGroupValues: action.payload,
                loading: false
            }
        case GET_EVENT_RESOURCES_GROUPS:
            return {
                ...state,
                eventResourceGroups: action.payload,
                loading: false
            }

        case GET_CENTERS:
            return {
                ...state,
                centers: action.payload,
                loading: false
            }

        case GET_CENTER_REPORTS:
            return {
                ...state,
                centerReports: action.payload,
                loading: false
            }

        case GET_CENTER_REPORT:
            return {
                ...state,
                centerReport: action.payload,
                loading: false
            }

        case GET_STATS:
            return {
                ...state,
                stats: action.payload,
                loading: false
            }

        case GET_ROOM:
            return {
                ...state,
                room: action.payload,
                loading: false
            }

        case GET_ROOM_TYPE_VALUES:
            return {
                ...state,
                roomTypeValues: action.payload,
                loading: false
            }
        case SET_LOADING:
            return {
                ...state,
                loading: true
            }

        default:
            return state
    }

}

export default EventReducer